import * as Sentry from '@sentry/react'
import React, { PureComponent } from 'react'
import { Provider } from 'react-redux'
import { MuiThemeProvider } from '@material-ui/core/styles'
import ErrorPage from './components/common/ErrorPage'
import store from './store'
import { theme } from './config/muiThemeConfig'
import ConnectedRootApp from './App'

// Reference: https://itecnote.com/tecnote/reactjs-could-not-find-store-in-either-the-context-or-props/
export default class StoredConnectedApp extends PureComponent {
  render() {
    return (
      <Sentry.ErrorBoundary fallback={<ErrorPage />}>
        <Provider store={store}>
          <MuiThemeProvider theme={theme}>
            <ConnectedRootApp />
          </MuiThemeProvider>
        </Provider>
      </Sentry.ErrorBoundary>
    )
  }
}



// WEBPACK FOOTER //
// ./src/StoreConnectedApp.js